import React from 'react';
import { ChanelBanner } from '../../../../Shared/Content/ProductDetail/ChanelProductBanner/ChanelProductBanner';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { ChanelTitle } from '../../../../Shared/Content/ProductDetail/ChanelProductTitle/ChanelProductTitle';
import { Price } from '../../../../../UI/Price/Price';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { BrandDescription } from '../../../../Shared/Content/ProductDetail/BrandDescription/BrandDescription';
import { ProductReviewStars } from '../../../../Shared/Content/ProductDetail/ProductReviewStars/ProductReviewStars';
import { ItemNumber } from '../../../../Shared/Content/ProductDetail/ProductItemNumber/ProductItemNumber';
import { ProductDetailForm } from '../../../../Shared/Content/ProductDetail/ProductDetailForm/ProductDetailForm';
import ChanelProductDetailSwatches from '../../../../Shared/Content/ProductDetail/ChanelProductDetailSwatches/ChanelProductDetailSwatches';
import ProductDetailAttribute from '../../../../Shared/Content/ProductDetail/ProductDetailAttribute/ProductDetailAttribute';
import { ChanelQuantity } from '../../../../Shared/Content/ProductDetail/ChanelProductQuantity/ChanelProductQuantity';
import ProductSocialMedia from '../../../../Shared/Content/ProductDetail/ProductSocialMedia/ProductSocialMedia';
import ProductDetailReviews from '../../../../Shared/Content/ProductDetail/ProductDetailReviews/ProductDetailReviews';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { AddToBrandFavorites } from '../../../../Shared/Content/ProductDetail/AddToBrandFavorites/AddToBrandFavorites';
import { AsNavFor } from '../ProductMainAndAltImages/ProductMainAndAltImages';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import { Link } from 'react-router-dom';
import { Quantity } from '../../../../Shared/Content/ProductDetail/ProductQuantity/ProductQuantity';
import ProductMisc from '../../../../Shared/Content/ProductDetail/ProductMisc/ProductMisc';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import WcPowerPage from '../../../../Shared/Content/ProductDetail/ProductDisplay/WcPowerPage';
import FindInStore from '../../../../Shared/Content/ProductDetail/FindInStore/FindInStore';
import ChanelBottomBanner from '../../../../Shared/Content/Chanel/ChanelBottomBanner';

export class ProductDisplayChanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: 770,
      isOpen: false,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
      },
    };

    this.zoomIndex = 0;
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  liveChatOnClickBeauty() {
    insideAPI.post('api/visitor/set_department', { department: 'Video' });
    window.openChatButtonClick();
  }

  openPhotoSwipeMain = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.setState({
      isOpen: true,
      options: {
        index: dataKey,
        closeOnScroll: false,
      },
    });
  };

  render() {
    var settings = {
      containsAlts: this.props.contentData.altImages ? true : false,
    };
    var preOrder = this.props.contentData.preOrder,
      previewItem = preOrder !== undefined && preOrder.previewEndDateMessage !== undefined ? true : false;
    let isInternetExclusive = this.props?.contentData?.auxVerbiage1?.includes('Internet Exclusive') || false;

    return (
      <section id='ProductDisplayChanel'>
        {this.props.passedFunctions.parentState.imageClickedOn ? (
          <React.Fragment>
            <div className='closeZoomBar'>
              <div className='closeContainer' onClick={this.props.passedFunctions.zoomedImageClose}>
                <CloseXIcon />
              </div>
            </div>
            <div className='zoomedImgContainer'>
              {this.props.contentData.altImages ? (
                <AsNavFor
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  zoomedImageClose={this.props.passedFunctions.zoomedImageClose}
                  mainImageClicked={this.props.passedFunctions.mainImageClicked}
                  isZoomed={true}
                />
              ) : (
                <MainImage
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  contentData={this.props.contentData}
                  mainImageClicked={this.props.passedFunctions.mainImageClicked}
                  zoomedImageClose={this.props.passedFunctions.zoomedImageClose}
                />
              )}
            </div>
          </React.Fragment>
        ) : (
          ''
        )}
        <PhotoSwipeZoom
          isOpen={this.state.isOpen}
          options={this.state.options}
          handleClose={this.handleClose}
          passedFunctions={this.props.passedFunctions}
          contentData={this.props.contentData}
          selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
          updateZoomIndex={this.updateZoomIndex}
        />
        <div className={`${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}>
          <ChanelBanner />
          <div className='row'>
            <div className='col-md-12 col-lg-10 '>
              <div className='row'>
                {this.props.passedAppFunctions.siteFormat != 'tablet' ? (
                  <div className={`${settings.containsAlts ? 'col-md-1 col-lg-1' : 'col-sm-0'} p-0 altCol`}>
                    <AltImages
                      contentData={this.props.contentData}
                      passedFunctions={this.props.passedFunctions}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                      passedAppFunctions={this.props.passedAppFunctions}
                      altClicked={this.props.altClicked}
                    />
                  </div>
                ) : (
                  ''
                )}
                <div className={`col-6`}>
                  {this.props.passedAppFunctions.siteFormat == 'desktop' || !this.props.contentData.altImages ? (
                    <MainImage
                      passedAppFunctions={this.props.passedAppFunctions}
                      contentData={this.props.contentData}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      // mainImageClicked={this.props.passedFunctions.mainImageClicked}
                      isZoomed={false}
                      openPhotoSwipe={this.openPhotoSwipe}
                    />
                  ) : null}
                  {this.props.passedAppFunctions.siteFormat != 'desktop' && this.props.contentData.altImages && (
                    <>
                      <MainImagePhotoSwipeZoom
                        isOpen={this.state.isOpen}
                        options={this.state.options}
                        passedFunctions={this.props.passedFunctions}
                        handleClose={this.handleClose}
                        contentData={this.props.contentData}
                        selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                        updateZoomIndex={this.updateZoomIndex}
                      />
                      <MainImageSlider
                        contentData={this.props.contentData}
                        passedFunctions={this.props.passedFunctions}
                        passedAppFunctions={this.props.passedAppFunctions}
                        selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                        openPhotoSwipeMain={this.openPhotoSwipeMain}
                        altClicked={this.state.altClicked}
                        altIndex={this.state.altIndex}
                      />
                      <div className='dds-stylitics-jumplink-wrapper'>
                        <a
                          href='#dds-stylitics-widget-title'
                          className='dds-stylitics-jumplink'
                          id='stylitics-jumplink'
                        >
                          How To Style
                        </a>
                      </div>
                    </>
                  )}
                  {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                    <span className='tapToZoom'>Tap image to zoom</span>
                  ) : (
                    ''
                  )}
                  {this.state.deviceWidth < 769 || this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                    //Alts displayed below MainImage for tablet.
                    <AltImages
                      contentData={this.props.contentData}
                      passedFunctions={this.props.passedFunctions}
                      vertical={false}
                      passedAppFunctions={this.props.passedAppFunctions}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                      altClicked={this.props.altClicked}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div className='col-md-6 col-lg-5 shopperActionsColumn'>
                  <ChanelTitle contentData={this.props.contentData} />
                  <ProductReviewStars
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    contentData={this.props.contentData}
                  />
                  {this.props.contentData.unavailableMessage == '' ||
                  typeof this.props.contentData.unavailableMessage == 'undefined' ? (
                    <Price pricing={this.props.contentData.pricing} />
                  ) : (
                    <div>
                      <Link to={`/brand/${this.props.contentData.personalization.urlFormattedBrandName}`}>
                        <button className='btn btn-secondary btn-block m-t-10 m-b-10'>
                          Shop All {this.props.contentData.personalization.brandName}
                        </button>
                      </Link>
                      <div id='preorder-alert' className='alert alert-danger' role='alert'>
                        {this.props.contentData.unavailableMessage}
                      </div>
                    </div>
                  )}
                  {/* <If test={!previewItem && (this.props.contentData.unavailableMessage == '' || typeof this.props.contentData.unavailableMessage == 'undefined')}>
                                        <AfterPayMessaging pricing={this.props.contentData.pricing} passedAppFunctions={this.props.passedAppFunctions} />
                                    </If> */}

                  {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
                    this.props.contentData.unavailableMessage == '' ||
                    typeof this.props.contentData.unavailableMessage == 'undefined' ? (
                      <ProductDetailForm
                        currentAttributeState={this.props.currentAttributeState}
                        passedFunctions={this.props.passedFunctions}
                        contentData={this.props.contentData}
                        wrapperClass={this.props.wrapperClass}
                      >
                        <ProductDetailAttribute
                          key={this.props.contentData.productId}
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                          updateAttribute={this.props.passedFunctions.updateAttribute}
                          updateAttrState={this.props.passedFunctions.updateAttrState}
                          currentAttributeState={this.props.currentAttributeState}
                          contentData={this.props.contentData}
                        />
                        {/* <ChanelProductDetailSwatches
                                                    swatchGroups={
                                                        this.props.passedFunctions.parentState.swatchGroups
                                                    }
                                                    passedFunctions={this.props.passedFunctions}
                                                    contentData={this.props.contentData}
                                                /> */}
                        <Quantity
                          updateQuantity={this.props.passedFunctions.updateQuantity}
                          quantity={this.props.passedFunctions.parentState.quantity}
                          quantityErrored={this.props.passedFunctions.parentState.quantityErrored}
                          contentData={this.props.contentData}
                          passedAppFunctions={this.props.passedAppFunctions}
                          forceQuantity={this.props.passedFunctions.forceQuantity}
                          maximumQuantity={3}
                        />
                        <button
                          className='btn btn-primary btn-block'
                          role='button'
                          type='button'
                          id='add-to-bag'
                          onClick={this.props.passedFunctions.ajaxAddToBag}
                        >
                          Add To Bag
                        </button>
                        {this.props.contentData.superCat == 'Beauty' ? (
                          <button
                            className='btn btn-secondary btn-block beauty-chat'
                            role='button'
                            type='button'
                            onKeyPress={this.liveChatOnClickBeauty}
                            onClick={this.liveChatOnClickBeauty}
                            manual_cm_sp='video+chat-_-beauty-_-product'
                          >
                            <span className='sr-only'>Opens a simulated dialog</span>
                            Chat with a Beauty Expert
                          </button>
                        ) : (
                          ''
                        )}
                        <WishListMessage
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />
                        {typeof window == 'undefined' || window.DILLARDS.country == 'US' ? (
                          <button
                            className='btn btn-tertiary'
                            role='button'
                            type='button'
                            id='add-to-wishlist'
                            onClick={this.props.passedFunctions.ajaxAddToWishlist}
                          >
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44'>
                              <title>heart</title>
                              <g data-name='Layer 2'>
                                <g data-name='Layer 1'>
                                  <path
                                    className='cls-1'
                                    d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                                  />
                                </g>
                              </g>
                            </svg>
                            Add To Wish List
                          </button>
                        ) : (
                          ''
                        )}
                        <AddToBrandFavorites
                          passedAppFunctions={this.props.passedAppFunctions}
                          contentData={this.props.contentData}
                          passedFunctions={this.props.passedFunctions}
                        />
                      </ProductDetailForm>
                    ) : (
                      ''
                    )
                  ) : (
                    <div id='error-message' className='alert alert-danger' role='alert'>
                      This item is not available for international purchase.
                    </div>
                  )}
                  {this.props.contentData.skus.length > 0 &&
                  !isInternetExclusive &&
                  this.props.passedAppFunctions.wasParms.allowFindInStore == 'true' ? (
                    <FindInStore currentAttributeState={this.props.currentAttributeState} />
                  ) : (
                    ''
                  )}
                  <ProductDescription
                    open={true}
                    previewItem={this.previewItem}
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <BrandDescription
                    open={false}
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <ProductMisc
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                  <ProductSocialMedia
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                  />
                </div>
              </div>
            </div>
            <div className='col-2 productRecsColumn'>
              <ProductRecs
                zoneName='PDPZ1'
                contentData={this.props.contentData}
                vertical={true}
                passedAppFunctions={this.props.passedAppFunctions}
              />
            </div>
          </div>
          <ChanelBottomBanner />
          <ProductDetailReviews
            contentData={this.props.contentData}
            passedAppFunctions={this.props.passedAppFunctions}
            passedFunctions={this.props.passedFunctions}
          />
        </div>
        <WcPowerPage {...this.props} />
      </section>
    );
  }
}

export default ProductDisplayChanel;
